<app-shive-grid #gridWrapperComponent [grid]="grid">
  <kendo-grid
    kendoGridSelectBy="id"
    scrollable="none"
    [data]="gridData()"
    [pageSize]="20"
    [selectable]="{ enabled: true, checkboxOnly: true }"
    [columnMenu]="{ filter: true }"
    #grid
  >
    <kendo-grid-checkbox-column
      [width]="40"
      [headerClass]="{ 'k-text-center': true }"
      class="list-selection-check"
      [resizable]="false"
      [columnMenu]="false"
      [showSelectAll]="true"
    >
    </kendo-grid-checkbox-column>

    <kendo-grid-column field="member.name" title="Bezeichnung" [class]="'cell-with-avatar'">
      <ng-template kendoGridCellTemplate let-row>
        <div class="k-d-inline-flex k-align-items-center">
          <app-shive-avatar [user]="row.member"></app-shive-avatar>
          <div class="member-name k-ml-3">{{ row.member | memberName }}</div>
        </div>
      </ng-template>
    </kendo-grid-column>

    @if (project.budgetType === BudgetOptions.HoursPerMember) {
      <kendo-grid-column field="member.budget" title="Budget" [class]="'!k-white-space-nowrap'">
        <ng-template kendoGridCellTemplate let-row>
          <div>
            @if (project.budgetType === BudgetOptions.HoursPerMember) {
              {{ row.spentSeconds | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }} /
              {{ row.budget | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }}
            }
          </div>
          <app-fuelbar [currentVal]="row.spentSeconds" [maxVal]="row.budget" [thin]="true">
          </app-fuelbar>
        </ng-template>
      </kendo-grid-column>
    }

    <kendo-grid-column
      field="member.expendedHours"
      title="Aufwand (h)"
      [class]="'!k-white-space-nowrap'"
    >
      <ng-template kendoGridCellTemplate let-row>
        {{ row.spentSeconds | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }}
      </ng-template>
    </kendo-grid-column>

    @if (project.expenditureType === ExpenditureRateOptions.HourlyRatePerMember) {
      <kendo-grid-column
        field="member.expendedFees"
        title="Aufwand (Euro)"
        [class]="'!k-white-space-nowrap'"
      >
        <ng-template kendoGridCellTemplate let-row>
          {{ row.spentFees | shiveCurrency }}
        </ng-template>
      </kendo-grid-column>
    }

    <kendo-grid-column
      field="member.employeeCosts"
      title="Mitarbeiterkosten"
      [class]="'!k-white-space-nowrap'"
    >
      <ng-template kendoGridCellTemplate let-row> {{ row.costs | shiveCurrency }}</ng-template>
    </kendo-grid-column>
  </kendo-grid>
</app-shive-grid>
